import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import Dashboard from '../src/pages/Dashboard/Dahboard'
import * as serviceWorker from './serviceWorker';

document.title = "CDL - Showroom Appointment Booking";
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
